import { useEffect, useId, useState } from 'react'
import { getUserTags } from '../../api/tags'

interface Props {
  username: string | null
  onSubmit: (tag: string) => void
  excludeTags?: string[]
  disabled?: boolean
  inputStyle?: React.CSSProperties
  buttonStyle?: React.CSSProperties
}

export function TagInput({ username, onSubmit, excludeTags, disabled, inputStyle, buttonStyle }: Props) {
  const [value, setValue] = useState('')
  const [allSuggestions, setAllSuggestions] = useState<string[]>([])
  const listId = useId()

  useEffect(() => {
    if (!username) return
    getUserTags(username)
      .then((tags) => setAllSuggestions(tags.map((t) => t.name)))
      .catch(() => {})
  }, [username])

  const suggestions = excludeTags && excludeTags.length > 0
    ? allSuggestions.filter((s) => !excludeTags.includes(s))
    : allSuggestions

  function commit() {
    const tag = value.trim().toLowerCase()
    if (!tag) return
    onSubmit(tag)
    setValue('')
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      e.preventDefault()
      commit()
    }
  }

  return (
    <div style={{ display: 'flex', gap: '0.3rem' }}>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        list={listId}
        placeholder="tag…"
        disabled={disabled}
        style={inputStyle}
      />
      <datalist id={listId}>
        {suggestions.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>
      <button type="button" onClick={commit} disabled={disabled || !value.trim()} style={buttonStyle}>
        +
      </button>
    </div>
  )
}
